"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const material_1 = require("@mui/material");
const react_1 = __importDefault(require("react"));
const lodash_1 = require("lodash");
const TabView_1 = __importDefault(require("../TabView"));
const GlobalSearchResult_1 = __importDefault(require("../../GlobalSearchResult/GlobalSearchResult"));
const Tabs = (0, material_1.styled)(TabView_1.default)(({ theme }) => ({
    paddingLeft: 0,
    paddingright: 0,
    width: "420px",
    "& .Mui-selected": {
        color: (0, lodash_1.get)(theme, "palette.dashboard.ocean"),
    },
}));
const tabIndicatorStyles = (theme) => ({
    backgroundColor: (0, lodash_1.get)(theme, "palette.dashboard.ocean"),
});
const noResultStyles = ({ theme }) => ({
    width: "fit-content",
    padding: theme.spacing(1),
    marginLeft: "auto",
    marginRight: "auto",
});
const NoResults = (0, material_1.styled)("div")(noResultStyles);
const NoResultError = (0, material_1.styled)("div")((props) => ({
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore  TODO: Fix these theme types or remove them so that styling can be done externally
    color: props.theme.palette.globalSearchError?.color,
    ...noResultStyles(props),
}));
const Results = (0, material_1.styled)("div")(({ theme }) => ({
    maxHeight: "660px",
    overflowY: "auto",
    "& > :nth-child(odd)": {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore TODO: Fix these theme types or remove them so that styling can be done externally
        backgroundColor: theme.palette.globalSearchResults?.backgroundColor,
    },
}));
const SearchResult = ({ isFetching, error, query, members, providers, url, onSelect, }) => {
    if (isFetching)
        return (react_1.default.createElement(NoResults, null,
            react_1.default.createElement(material_1.CircularProgress, null)));
    if (error)
        return (react_1.default.createElement(NoResultError, null,
            "Unable to complete search: ",
            error.message));
    if (!query)
        return null;
    return (react_1.default.createElement(Tabs, { tabs: [
            {
                title: "Members",
                results: members,
                link: `${url}/member-index/members`,
            },
            {
                title: "Providers",
                results: providers,
                link: `${url}/provider-index/providers`,
            },
        ].map(({ title, results, link }) => ({
            title,
            content: results.length ? (react_1.default.createElement(Results, { key: `${title}-results` }, results.map(({ top, bottom, id }) => (react_1.default.createElement(GlobalSearchResult_1.default, { key: id, topInfo: top, bottomInfo: bottom, link: `${link}/${id}`, handleSelection: onSelect }))))) : (react_1.default.createElement(NoResults, null,
                "No ",
                title.toLowerCase(),
                " found.")),
        })), variant: "fullWidth", TabIndicatorProps: { sx: tabIndicatorStyles } }));
};
exports.default = SearchResult;
